import { useCallback, useEffect, useState } from "react";
import i18n from "src/i18n/config";
import {
  fetchShopifySalesAnalytics,
  type ShopifySalesAnalyticsResponse,
  type ShopifySalesCrossFilterRequest,
} from "src/services/ShopifySalesProductAPI";
import type { ApiLang } from "src/utils/apiLang";

export function useShopifySalesAnalytics(
  startDate: string,
  endDate: string,
  lang: ApiLang,
  crossFilter?: ShopifySalesCrossFilterRequest | null,
  tenantId?: number,
) {
  const [data, setData] = useState<ShopifySalesAnalyticsResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    if (!startDate || !endDate) {
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const response = await fetchShopifySalesAnalytics(startDate, endDate, lang, {
        tenantId,
        crossFilter: crossFilter ?? undefined,
      });
      setData(response);
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : i18n.t("shopifyGeo.errors.loadFailed")
      );
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate, lang, crossFilter, tenantId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}
